import { gql } from '@apollo/client'

export const ACTION_QUERY = gql`
  query action($id: ID!) {
    action(id: $id) {
      keyword
      hint
      disputeValue
      editorActive
      claimDate
      fileNumber
      closingResult
      closingResultDetail
      closingTypeId
      closingTypeOther
      communicationViaCustomerPortal
      rightActualProcessingType
      rsvLegalArea {
        id
        title
      }
      rsvLegalAreaId
      settlementComments
      actualProcessingType {
        id
        title
        legalAdviceOnly
        projectId
      }
      actualProcessingTypeId
      intendedProcessingType {
        id
        title
      }
      intendedProcessingTypeId
      contactPersonFirstname
      contactPersonLastname
      contactPersonEmail
      contactPersonPhoneNumber
      contactPersonMobileNumber
      contactPersonSalutation
      contactPersonRelationToPolicyholder
      conflictContactFirstname
      conflictContactLastname
      conflictContactEmail
      conflictContactPhoneNumber
      conflictContactMobileNumber
      conflictContactRelationToConflictPartner
      policyholderFirstname
      policyholderLastname
      policyholderEmail
      policyholderPlace
      policyholderPostalCode
      policyholderPhoneNumber
      policyholderMobileNumber
      policyholderSalutation
      policyNumber
      claimNumber
      conflictPartnerCompany
      conflictPartnerPostalCode
      conflictPartnerSalutation
      conflictPartnerFirstname
      conflictPartnerLastname
      conflictPartnerEmail
      conflictPartnerPhoneNumber
      conflictPartnerPlace
      conflictPartnerStreet
      conflictPartnerHouseNumber
      conflictPartnerMobileNumber
      conflictPartnerSalutation
      needsCollisionDetection
      noCollisionByHuman
      completeReason
      conflictPartnerAgreesMediation
      conflictPartnerAgreesToCoverCosts
      contactSuccessful
      contactType
      costs
      costsCoveredByKp
      createdAt
      customerComments
      customerRating
      customerMessageType
      dataset
      date
      firstCall
      id
      informReason
      internalTransferReason
      note
      legalAdvice
      mailSentAt
      attorneyStatus
      noMailSentReason
      attorneyReason
      attorneyType
      policyholderAgreesMediation
      processing {
        agentId
        id
        m2Case {
          id
        }
        involvedUsers {
          id
          name
        }
      }
      payment {
        id
        amount
        amountDecimal
        email
        salutation
        firstname
        lastname
        status
        stripeCheckoutUrl
        paymentRequestedAt
        paymentReceivedAt
        createdAt
        updatedAt
        user {
          email
          firstname
          lastname
        }
      }
      processingId
      type
      updatedAt
      user {
        id
        name
        role
      }
      userId
      visibleForOtherProcessings
      visibleForPolicyholder
      uploads {
        id
        attachmentUrl
        attachmentFilename
      }
    }
  }
`
